/**
 * Coerces API string/number prices for safe `.toFixed` in bot result cards.
 * Defaults to whole numbers (no decimals) to match the rest of the B2C app,
 * which rounds displayed prices (product cards, the V2 cart) to integers.
 */
export function formatBotPrice(value: unknown, fractionDigits = 0): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) {
    return (0).toFixed(fractionDigits);
  }
  return n.toFixed(fractionDigits);
}
